<ng-container *ngIf="isMaintenanceMode">
  <div class="d-flex maintenance-wrapper">
    <div class="d-flex w-100 justify-content-center align-items-center">
      <main class="px-3">
        <h2>surveys is currently undergoing maintenance.</h2>
        <h4>Please check back later.</h4>
      </main>
    </div>
  </div>
</ng-container>

<app-authentication-cover [visible]="!isLoggedIn" [appTitle]="appTitle"></app-authentication-cover>
<ng-container *ngIf="isLoggedIn && !isMaintenanceMode">

  <app-header [appTitle]="appTitle"></app-header>

  <div class="container-fluid">
    <div class="row">
      <nav id="navSidebar" class="col-sm-1 d-md-block sidebar" [ngClass]="{'toggled' : isNavbarVisible}">
        <div class="flex-shrink-0 pt-3">
          <div class="toggle-control">
            <div class="btn btn-link p-0" (click)="toggleSideNav()">
              <fa-icon class="expand" [icon]="faBars"></fa-icon>
              <fa-icon class="close" [icon]="faXmark"></fa-icon>
            </div>
          </div>
          <ul class="list-unstyled ps-0">
            <li class="p-1">
              <a class="nav-link" routerLink="/dashboard" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">
                Dashboard
              </a>
            </li>
            <li class="border-top my-3"></li>
            <li class="p-1">
              <a class="nav-link" [routerLink]="['/clients-to-call']">
                Client Surveys
              </a>
            </li>
            <ng-container *ngIf="isAdmin">
              <li class="border-top my-3"></li>
              <li class="p-1">
                <a class="nav-link" routerLink="/admin" routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }">
                  Admin
                </a>
              </li>
            </ng-container>
          </ul>
        </div>
      </nav>
      <main class="col-sm-11 ms-sm-auto px-md-4">

        <router-outlet *ngIf="!isIframe"></router-outlet>
        <app-toast></app-toast>

      </main>
    </div>
  </div>
  <!-- Some styling helpers which can be used in dev -->
  <!-- <div style="
    position: fixed;
    top: 90%;
    left: 50%;
    z-index: 10000;
    transform: translate(-50%, -50%);
    background: rgba(247, 201, 241, 0.4);
    padding: .5rem 1rem;
    border-radius: 30px;
">
    <div class="d-block d-sm-none">Extra Small (xs)</div>
    <div class="d-none d-sm-block d-md-none">Small (sm)</div>
    <div class="d-none d-md-block d-lg-none">Medium (md)</div>
    <div class="d-none d-lg-block d-xl-none">Large (lg)</div>
    <div class="d-none d-xl-block d-xxl-none">X-Large (xl)</div>
    <div class="d-none d-xxl-block">XX-Large (xxl)</div>
  </div> -->
</ng-container>